import React, { useRef, useState } from "react";

import {
    Modal,
    Button,
    message,
} from "antd";

import SignatureCanvas from "react-signature-canvas";
import { uploadSignatureImage } from "../../../Services/appointmentService";
import { BASE_IMAGE_API_GET } from "../../../config";

export default function ConcernAppointmentModal({
    open,
    onClose,
    appointment,
}) {

    const sigCanvas = useRef(null);

    const [loading, setLoading] = useState(false);

    const sessionUserData = JSON.parse(
        sessionStorage.getItem("userData") || "{}"
    );

    const clearSignature = () => {
        sigCanvas.current.clear();
    };

    const handleSaveSignature = async () => {

        if (sigCanvas.current.isEmpty()) {
            message.error("Please add signature");
            return;
        }
    
        try {
    
            setLoading(true);
    
            // GET CANVAS
            const canvas =
            sigCanvas.current.getCanvas();
    
            // CONVERT TO BLOB
            canvas.toBlob(async (blob) => {
    
                if (!blob) {
                    message.error(
                        "Failed to process signature"
                    );
                    return;
                }
    
                const file = new File(
                    [blob],
                    `signature_${Date.now()}.png`,
                    {
                        type: "image/png",
                    }
                );
    
                const payload = new FormData();
    
                payload.append(
                    "AppointmentId",
                    appointment?.AppointmentId
                );
    
                payload.append(
                    "UpdatedBy",
                    sessionUserData?.Id || 1
                );
    
                // IMPORTANT
                payload.append(
                    "ImageUrl",
                    file,
                    file.name
                );
    
                const response =
                    await uploadSignatureImage(payload);
    
                console.log("UPLOAD RESPONSE", response);
    
                if (
                    response?.status === 200 ||
                    response?.success
                ) {
    
                    message.success(
                        "Signature uploaded successfully"
                    );
    
                    onClose();
    
                } else {
    
                    message.error(
                        response?.message ||
                        response?.response ||
                        "Failed to upload signature"
                    );
                }
    
                setLoading(false);
    
            }, "image/png");
    
        } catch (error) {
    
            console.log(error);
    
            message.error(
                error?.response?.data?.message ||
                error?.response?.data?.response ||
                "Failed to upload signature"
            );
    
            setLoading(false);
        }
    };

    return (
        <Modal
            open={open}
            onCancel={onClose}
            footer={null}
            width={700}
            centered
        >
            <div className="p-2">

                {/* HEADER */}
                <div className="d-flex align-items-center gap-3 mb-4">

                    <div
                        className="d-flex align-items-center justify-content-center"
                        style={{
                            width: 56,
                            height: 56,
                            borderRadius: 18,
                            background:
                                "linear-gradient(135deg,#2563eb,#3b82f6)",
                        }}
                    >
                        <i className="bi bi-pen text-white fs-3"></i>
                    </div>

                    <div>
                        <h4 className="fw-bold mb-1">
                            Patient Consent Signature
                        </h4>

                        <p className="text-muted mb-0">
                            Please collect patient signature
                            before consultation
                        </p>
                    </div>
                </div>

                {/* CONSENT */}
                <div
                    className="rounded-4 p-4 mb-4"
                    style={{
                        background: "#f8fafc",
                        border: "1px solid #e2e8f0",
                    }}
                >
                    <div className="d-flex align-items-center gap-2 mb-2">
                        <i className="bi bi-shield-check text-success"></i>

                        <h6 className="fw-bold mb-0">
                            Consent Declaration
                        </h6>
                    </div>

                    <p className="text-muted mb-0">
                        I confirm that the above details
                        are correct and I consent to the
                        proposed dental consultation and
                        treatment.
                    </p>
                </div>

                {/* SIGNATURE PAD */}
                {/* SIGNATURE SECTION */}

{appointment?.SignatureUrl ? (

// VIEW SIGNATURE
<div
    className="rounded-4 overflow-hidden mb-4 p-3 text-center"
    style={{
        border: "2px solid #dcfce7",
        background:
            "linear-gradient(180deg,#f0fdf4,#ffffff)",
    }}
>

    <div className="d-flex align-items-center justify-content-between mb-3">

        <div className="d-flex align-items-center gap-2">
            <i className="bi bi-check-circle-fill text-success"></i>

            <h6 className="fw-bold mb-0 text-success">
                Signature Available
            </h6>
        </div>

        <span className="badge bg-success-subtle text-success px-3 py-2 rounded-pill">
            Verified
        </span>
    </div>

    <div
        className="bg-white rounded-4 p-3 shadow-sm"
        style={{
            border: "1px solid #dcfce7",
        }}
    >
        <img
            src={`${BASE_IMAGE_API_GET}${appointment?.SignatureUrl}`}
            alt="Patient Signature"
            className="img-fluid"
            style={{
                maxHeight: "220px",
                objectFit: "contain",
            }}
        />
    </div>

</div>

) : (

// SIGNATURE PAD
<div
    className="rounded-4 overflow-hidden mb-4"
    style={{
        border: "2px dashed #cbd5e1",
        background: "#fff",
    }}
>
    <SignatureCanvas
        ref={sigCanvas}
        penColor="#111827"
        canvasProps={{
            width: 620,
            height: 220,
            className: "signature-canvas",
        }}
    />
</div>

)}

                {/* ACTIONS */}
                {!appointment?.SignatureUrl && (
                    <div className="d-flex justify-content-between">

                        <Button
                            size="small"
                            danger
                            ghost
                            onClick={clearSignature}
                            icon={
                                <i className="bi bi-eraser"></i>
                            }
                            style={{
                                borderRadius: 12,
                                height: 46,
                            }}
                        >
                            Clear
                        </Button>

                        <div className="d-flex gap-2">

                            <Button
                                size="small"
                                onClick={onClose}
                                style={{
                                    borderRadius: 12,
                                    height: 46,
                                }}
                            >
                                Cancel
                            </Button>

                            <Button
                                type="primary"
                                size="small"
                                loading={loading}
                                onClick={handleSaveSignature}
                                icon={
                                    <i className="bi bi-cloud-upload text-white"></i>
                                }
                                style={{
                                    borderRadius: 12,
                                    height: 46,
                                    border: "none",
                                    background:
                                        "linear-gradient(135deg,#16a34a,#22c55e)",
                                }}
                            >
                                Save Signature
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        </Modal>
    );
}